__turbopack_context__.v({
  "button": "_1VTCbq_button",
  "centered": "_1VTCbq_centered",
  "container": "_1VTCbq_container",
  "item": "_1VTCbq_item",
  "paper": "_1VTCbq_paper",
  "three": "_1VTCbq_three",
  "two": "_1VTCbq_two",
});
